<template>
  <Layout>
    <div class="row mb-3">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between pb-0">
        <div class="d-flex align-items-center">
          <div>
              <b-button pill variant="light" @click="backUrl">
                <i class="mdi mdi-18px mdi-arrow-left"></i>
              </b-button>
          </div>
          <h4 class="ml-2 mb-0 font-size-18">{{ title }}</h4>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
      <!-- <hr> -->
    </div>
  </div>

  <!-- Person details & top mention -->
  <div class="row" v-if="id1 && id2">
      <div class="col-12">
         <Account
            :id1="id1"
            :id2="id2"
        />
      </div>
  </div>

  <div class="row mt-2 mb-4" v-if="!id1 && !id2">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
             <div class="col-6">
              <div class="row">
                <div class="col-sm-12">
                    <h6><b>Account 1</b></h6>
                    <div class="media" v-if="selected[0]">
                      <img
                        :src="avatar+selected[0].picture"
                        class="mr-3 rounded-circle avatar-sm"
                        alt="user-pic" v-if="selected[0].picture_hd"
                        />
                        
                      <img :src="selected[0].picture" alt="img" class="mr-3 rounded-circle avatar-sm" v-if="selected[0].picture && !selected[0].picture_hd">

                      <img
                        src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                        class="mr-3 rounded-circle avatar-sm"
                        alt="user-pic" v-if="!selected[0].picture && !selected[0].picture_hd"
                        />
                      <div class="media-body">
                        <b> {{selected[0].full_name}}</b> <span v-if="selected[0].verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span> <br>
                        <span class="text-secondary"> @{{selected[0].account}}</span> <br>
                        <p class="text-secondary">{{ $t('all.updated') }}: {{selected[0].updated_at}} </p> 
                      </div>
                    </div>
                    <div class="media" v-else>
                     <span>Select Account</span>
                    </div>
                </div>
              </div>
             </div>
             <div class="col-6">
               <div class="row">
                 <div class="col-sm-12">
                    <h6><b>Account 2</b></h6>
                    <div class="media" v-if="selected[1]">
                      <img
                        :src="avatar+selected[1].picture"
                        class="mr-3 rounded-circle avatar-sm"
                        alt="user-pic" v-if="selected[1].picture_hd"
                        />
                      <img :src="selected[1].picture" alt="img" class="mr-3 rounded-circle avatar-sm" v-if="selected[1].picture && !selected[1].picture_hd">
                      <img
                        src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                        class="mr-3 rounded-circle avatar-sm"
                        alt="user-pic" v-if="!selected[1].picture && !selected[1].picture_hd"
                        />
                      <div class="media-body">
                        <b> {{selected[1].full_name}}</b> <span v-if="selected[1].verified == true"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span> <br>
                        <span class="text-secondary"> @{{selected[1].account}}</span> <br>
                        <p class="text-secondary">{{ $t('all.updated') }}: {{selected[1].updated_at}} </p> 
                      </div>
                    </div>
                    <div class="media" v-else>
                     <span>Select Account</span>
                    </div>
                </div>
              </div>
             </div>
             </div>
             <div class="col-12 text-right" v-if="selected[1]">
                <button class="btn btn-success" @click="compareAccount(selected[0].account, selected[1].account)">
                <i class="bx bx-user"></i> Compare
                </button>
             </div>
            </div>
            <!-- Table -->
          </div>
      </div>
  </div>
   
  <div class="row mt-2 mb-4" v-if="!id1 && !id2">
 
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="row mt-4">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                {{ $t('button.show') }}&nbsp;&nbsp;
                <b-form-select v-model="perPage" size="sm" :options="pageOptions" class="mx-0"></b-form-select>&nbsp;&nbsp;{{ $t('button.entries') }} 
              </label>
                  </div>
          </div>
          <!-- Search -->
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_filter" class="dataTables_filter text-md-right">
              <label class="d-inline-flex align-items-center">
                {{ $t('button.search-data') }}:
                <b-form-input
                  v-model="filter"
                  type="search"
                  :placeholder="$t('all.searchh')"
                  class="form-control form-control ml-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <!-- End search -->
        </div>
        <!-- Table -->
        <div class="table-responsive mb-0">
          <b-table
            :items="tableData"
            :fields="fields"
            striped bordered
            responsive="sm"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :filter="filter"
            :filter-included-fields="filterOn"
          >
          <template #cell(no)="row" width="4%">
              <div class="mt-2">
                {{row.item.no}}
              </div>
          </template>
          <template #cell(bulk)="row" width="3%">
                <b-form-checkbox
                class="text-center mt-2"
                  v-model="selected"
                  :value="row.item">
                </b-form-checkbox>
          </template>
            <template #cell(account)="row"> 
            <div class="col-sm-12">
                <div class="media">
                    <img
                      :src="avatar+row.item.picture"
                      class="mr-3 rounded-circle avatar-sm"
                      alt="user-pic" v-if="row.item.picture_hd"
                      />
                      
                    <img :src="row.item.picture" alt="img" class="mr-3 rounded-circle avatar-sm" v-if="row.item.picture && !row.item.picture_hd">

                    <img
                      src="https://img.icons8.com/ios/240/000000/user-male-circle.png"
                      class="mr-3 rounded-circle avatar-sm"
                      alt="user-pic" v-if="!row.item.picture && !row.item.picture_hd"
                      />
                  <div class="media-body">
                    <b> {{row.item.full_name}}</b> <span v-if="row.item.verified == 1"><i class="my-auto ml-1 text-primary mdi mdi-check-decagram mdi-18px"></i></span> <br>
                    <span class="text-secondary"> @{{row.item.account}}</span> <br>
                    <p class="text-secondary">{{ $t('all.updated') }}: {{row.item.updated_at}} </p> 
                  </div>
                </div>
            </div>
            </template>
          </b-table>

            <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                      <div class="spinner-border text-secondary" role="status" v-if="loadingInfo">
                  </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="!loadingInfo && rows > 10">
          <div class="col-2 col-xl-1">
              <!-- <div v-if="selected[0]">
                <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
              </div> -->
              <label class="d-inline-flex align-items-center">
                Page
                <b-form-input
                  v-model="currentPage"
                  placeholder="Page"
                  class="form-control w-10 form-control ml-2"
                ></b-form-input>
              </label>
          </div>
          <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
            <div class="dataTables_paginate paging_simple_numbers float-right">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
  </Layout>
</template>

<script>
import InstaService from "@/helpers/osintgram.service.js";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import axios from 'axios';
import moment from 'moment';
import Particle from "./particle.vue";
import SocmedService from "@/helpers/socmed.service";
import Swal from "sweetalert2";
import PreferenceService from "@/helpers/preference.service.js";
import Account from "./compare-account.vue";
// import { tableData } from "./dataAdvancedtable";

export default {
  page: {
    title: "Tools Instagram",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Particle, Account },
  data() {
    return {
      id1: this.$route.query.account1,
      id2: this.$route.query.account2,
      avatar: process.env.VUE_APP_BASE_API_URL_OSINT+'stream-profil/?name=',
      avatar_instagram:'https://img.icons8.com/ios/240/000000/user-male-circle.png',
      loading: false,
      search: false,
      result:false,
      totalResult:"",
      error:"",
      dnf:false,
      searchKey: "",
      loadingInfo: false,
      searchResult: [],
      searchResultOsint:[],
      tableData:[],
      selected: [],
		  selectAll: false,
      search:false,
      title: "Instagram Compare",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Instagram",
          active: true
        }
      ],
      totalRows: 1,
      totalAccount:'',
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "no", class: 'text-center', thStyle: { width: "3%" }, label:'No'},
        { key: "bulk",  thStyle: { width: "2%" }, label:'#'},
        { key: "id_instagram", thClass: 'd-none', tdClass: 'd-none'},
        { key: "user_id", thClass: 'd-none', tdClass: 'd-none'},
        { key: "picture", thClass: 'd-none', tdClass: 'd-none'},
        { key: "updated_at", thClass: 'd-none', tdClass: 'd-none'},
        { key: "full_name", thClass: 'd-none', tdClass: 'd-none'},
        { key: "account", sortable: true,  label: this.$t('instagram.account')},
        { key: "followers", sortable: true,  label: this.$t('instagram.followers') },
        { key: "following", sortable: true,  label: this.$t('instagram.following') },
        { key: "media", sortable: true,  label: this.$t('instagram.post') },
      ]
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    }
  },
  methods:{
        select() {
        // console.log('selected');
            this.selected = [];
            if (!this.selectAll) {
                for (let i in this.tableData) {
                    this.selected.push(this.tableData[i].id_instagram);
                }
            }
        },

        listInstagram(){
          this.loadingInfo = true,
          SocmedService.getAllInstagram()
          .then(response => {
                    this.tableData = []
                    this.totalAccount = response.data.data.length;
                    response.data.data.forEach((val, index) => {
                        const data = { 
                        "no" : index+1, 
                        "id_instagram" : val.id_instagram,
                        "user_id" : val.user_id,
                        "account" : val.account,
                        "full_name" : val.full_name,
                        "verified" : val.is_verified,
                        "picture" : val.picture,
                        "picture_hd" : val.picture_hd,
                        "followers" : val.followers,
                        "following" : val.following,
                        "media" : val.media,
                        "created_at" : this.formatDate(val.created_at),
                        "updated_at" : this.formatDate(val.updated_at),
                        }
                        this.tableData.push(data);
                        this.loadingInfo = false;
                    });
                })
                .catch(err => {
                    console.log(err);
                    this.loadingInfo = false;
            });
        },


        
        formatDate(value){
            return moment(value).format("dddd, YYYY-MM-DD hh:mm");
        },

        removeSpace(value){
          let str = value.replace(/\s/g, '');
          return str;
        },

        compareAccount(account1, account2){
          return location.replace('/instagram-compare?account1='+account1+'&account2='+account2);
        },

        backUrl(){
          return location.replace('/instagram-compare');
        }
  },
  mounted(){
    this.totalRows = this.items.length;
    this.listInstagram();
  }
};
</script>

<style scoped>
.loading{
  padding-top:20%;
  padding-bottom:20%;
}
</style>